import React from 'react';
import { StarIcon, MapPinIcon, PhoneIcon, NavigationIcon } from 'lucide-react';
export function StoreLocator() {
  const stores = [{
    name: 'Caversham',
    rating: 4.5,
    reviews: 560,
    services: ['DIY Dog Wash', 'Pool Testing']
  }, {
    name: 'Kelmscott',
    rating: 4.6,
    reviews: 378,
    services: ['DIY Dog Wash', 'Aquarium Testing']
  }, {
    name: 'Malaga',
    rating: 4.6,
    reviews: 189,
    services: ['Pool Testing', 'Carry to Car']
  }, {
    name: 'Midland',
    rating: 4.5,
    reviews: 416,
    services: ['DIY Dog Wash', 'Carry to Car']
  }, {
    name: 'Wangara',
    rating: 4.6,
    reviews: 340,
    services: ['DIY Dog Wash', 'Pool Testing']
  }, {
    name: 'Whitfords',
    rating: 4.5,
    reviews: 87,
    services: ['Aquarium Testing', 'Carry to Car']
  }];
  return <section className="section-padding bg-warm-50 relative" data-id="element-336">
      {/* Stylized Map Background */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#0047AB 1px, transparent 1px)',
      backgroundSize: '20px 20px'
    }} data-id="element-337"></div>

      <div className="container-wide relative z-10" data-id="element-338">
        <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-339">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-blue-100 text-brand-blue mb-6 shadow-sm" data-id="element-340">
            <MapPinIcon className="w-8 h-8" data-id="element-341" />
          </div>
          <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-gray-900 mb-4" data-id="element-342">
            Find Your Local Store
          </h2>
          <p className="text-lg text-gray-600" data-id="element-343">
            Six stores across Perth, open 7 days. Real staff ready to help.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-344">
          {stores.map((store, index) => <div key={index} className="bg-white rounded-2xl p-6 flex flex-col shadow-sm hover:shadow-elevated transition-all duration-300 border border-gray-100 group" data-id="element-345">
              <div className="flex justify-between items-start mb-4" data-id="element-346">
                <div data-id="element-347">
                  <h3 className="font-heading font-bold text-2xl text-gray-900 mb-1 flex items-center gap-2 group-hover:text-brand-blue transition-colors" data-id="element-348">
                    {store.name}
                  </h3>
                  <div className="flex items-center gap-1.5 text-sm" data-id="element-349">
                    <div className="flex text-yellow-500" data-id="element-350">
                      <StarIcon className="w-4 h-4 fill-current" data-id="element-351" />
                    </div>
                    <span className="font-bold text-gray-900" data-id="element-352">
                      {store.rating}
                    </span>
                    <span className="text-gray-500" data-id="element-353">({store.reviews})</span>
                  </div>
                </div>
                <span className="badge-green whitespace-nowrap shadow-sm" data-id="element-354">
                  Open 7 Days
                </span>
              </div>

              <div className="mb-6 flex-grow" data-id="element-355">
                <div className="text-xs font-bold text-gray-400 mb-2 uppercase tracking-wider" data-id="element-356">
                  Key Services
                </div>
                <div className="flex flex-wrap gap-2" data-id="element-357">
                  {store.services.map((service, i) => <span key={i} className="px-2.5 py-1 bg-warm-50 text-gray-700 text-xs rounded-md font-medium border border-warm-200" data-id="element-358">
                      {service}
                    </span>)}
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3 mt-auto" data-id="element-359">
                <button className="btn-primary py-2.5 text-sm flex items-center justify-center gap-1.5" data-id="element-360">
                  <NavigationIcon className="w-4 h-4" data-id="element-361" />
                  Directions
                </button>
                <button className="btn-secondary py-2.5 text-sm flex items-center justify-center gap-1.5 bg-white" data-id="element-362">
                  <PhoneIcon className="w-4 h-4" data-id="element-363" />
                  Call Store
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}